import { Grid, Typography, Box, IconButton } from "@mui/material";
import BootstrapTooltip from "../../../components/bootstrapTooltip/bootstrapTooltip";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import UnfoldMoreOutlinedIcon from "@mui/icons-material/UnfoldMoreOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import ISortOptions from "../interface/iSortOptions";

const AppointmentOverviewListHead = () => {
  const {
    sortOptions,
    sortParticipants,
  }: {
    sortOptions: ISortOptions;
    sortParticipants: () => void;
  } = React.useContext(AppointmentOverviewContext);

  return (
    <Grid
      container
      sx={{
        mb: 1,
        backgroundColor: "#eee",
        borderRadius: 2,
        px: 2,
        py: 0.5,
        fontWeight: "bold",
        textTransform: "uppercase",
      }}
    >
      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" color="initial">
          Datum / Uhrzeit
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="caption" color="initial">
            Typ | Teilnehmer:in
          </Typography>
          <Box>
            <BootstrapTooltip
              placement="right"
              title={
                sortOptions.participant === "asc"
                  ? "Teilnehmer:in aufsteigend sortieren"
                  : sortOptions.participant === "desc"
                  ? "Teilnehmer:in absteigend sortieren"
                  : "Teilnehmer:in nicht sortiert"
              }
              children={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    width: "100%",
                  }}
                >
                  <IconButton
                    aria-label="edit-button"
                    onClick={sortParticipants}
                  >
                    {sortOptions.participant === "asc" ? (
                      <ExpandLessOutlinedIcon fontSize="small" />
                    ) : sortOptions.participant === "desc" ? (
                      <ExpandMoreOutlinedIcon fontSize="small" />
                    ) : (
                      <UnfoldMoreOutlinedIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>
              }
            />
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" color="initial">
          Coach:in
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        md={1}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" color="initial">
          Status
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AppointmentOverviewListHead;
